import { contratosInitialState } from '../../pages/Contratos/Fluxos/Contratos';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import {
  CLEARED_ALL_TEMPLATES_ACTION,
  CLEARED_CONTRATOS_PAGE_ACTION,
  CLEARED_COOPERATIVA_BY_COD_ACTION,
  DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
  LOADED_ALL_CONTRATO_TIPOS,
  LOADED_ALL_FLUXO_TIPOS,
  LOADED_CONTRATOS_PAGE_ACTION,
  LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
  LOADED_COOPERATIVA_BY_COD_ACTION,
  LOADED_MACROS_POR_TEMPLATE_ACTION,
  LOADED_TEMPLATES_ACTION,
  LOADED_TEMPLATE_ACTION,
  LOADING_ALL_CONTRATO_TIPOS,
  LOADING_ALL_FLUXO_TIPOS,
  LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
  LOADING_COOPERATIVA_BY_COD_ACTION,
  LOADING_MACROS_POR_TEMPLATE_ACTION,
} from './ContratosActions';

const TEMPLATE_EDITING_NOT_NULL_PROPS = ['nome', 'htmlTemplate'];

const TEMPLATE_EDITING_INITIAL_STATE = {
  id: null,
  nome: '',
  htmlTemplate: '',
};

const PAGE_LIST_INITIAL_STATE = {
  filters: {
    ...contratosInitialState.filters,
  },
  busca: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const COOPERATIVA_BY_COD_NOT_NULL_PROPS = [
  'complemento',
  'cnpj',
  'nomeFantasia',
  'codigoEntidade',
  'endereco',
  'numero',
  'bairro',
  'municipio',
  'uf',
  'cep',
  'tipoEndereco',
  'email',
];

const COOPERATIVA_BY_COD_INITIAL_STATE = {
  complemento: '',
  cnpj: '',
  nomeFantasia: '',
  codigoEntidade: '',
  endereco: '',
  numero: '',
  bairro: '',
  municipio: '',
  uf: '',
  cep: '',
  tipoEndereco: '',
  email: '',
};

const INITIAL_STATE = {
  allTemplates: [],
  arquivosAuxiliaresList: [],
  cooperativaByCod: COOPERATIVA_BY_COD_INITIAL_STATE,
  downloadingArquivoAuxiliar: false,
  editingTemplate: TEMPLATE_EDITING_INITIAL_STATE,
  loadingArquivosAuxiliaresList: false,
  loadingCooperativaByCod: false,
  loadingTemplateMacros: false,
  loadingTiposContratos: false,
  loadingTiposFluxos: false,
  pageList: PAGE_LIST_INITIAL_STATE,
  pageSize: TOTAL_ITEMS_FOR_PAGE,
  templateMacros: [],
  tiposContratos: [],
  tiposFluxos: [],
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    status: newPageList.status,
    coop: newPageList.coop,
    assessor: newPageList.assessor,
    busca: newPageList.busca,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    filters: newPageList.filters,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

export default function ContratosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEARED_ALL_TEMPLATES_ACTION:
      return { ...state, allTemplates: [] };
    case LOADED_TEMPLATES_ACTION:
      return { ...state, allTemplates: action.payload };
    case LOADED_TEMPLATE_ACTION:
      return {
        ...state,
        editingTemplate: transformNullIntoEmpty(
          action.payload,
          TEMPLATE_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_MACROS_POR_TEMPLATE_ACTION:
      return { ...state, loadingTemplateMacros: action.payload };
    case LOADED_MACROS_POR_TEMPLATE_ACTION:
      return { ...state, templateMacros: action.payload };
    case CLEARED_CONTRATOS_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case LOADED_CONTRATOS_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case CLEARED_COOPERATIVA_BY_COD_ACTION:
      return { ...state, cooperativaByCod: COOPERATIVA_BY_COD_INITIAL_STATE };
    case LOADING_COOPERATIVA_BY_COD_ACTION:
      return { ...state, loadingCooperativaByCod: action.payload };
    case LOADED_COOPERATIVA_BY_COD_ACTION:
      return {
        ...state,
        cooperativaByCod: transformNullIntoEmpty(
          action.payload,
          COOPERATIVA_BY_COD_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION:
      return { ...state, loadingArquivosAuxiliaresList: action.payload };
    case LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION:
      return { ...state, arquivosAuxiliaresList: action.payload };
    case DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION:
      return { ...state, downloadingArquivoAuxiliar: action.payload };
    case LOADED_ALL_FLUXO_TIPOS:
      return { ...state, tiposFluxos: action.payload };
    case LOADING_ALL_FLUXO_TIPOS:
      return { ...state, loadingTiposFluxos: action.payload.loading };
    case LOADED_ALL_CONTRATO_TIPOS:
      return { ...state, tiposContratos: action.payload };
    case LOADING_ALL_CONTRATO_TIPOS:
      return { ...state, loadingTiposContratos: action.payload.loading };
    default:
      return state;
  }
}
